import i18n from "@plugins/i18n.ts";
import AcpHtml5InteractiveGenerationContentSubpage from "@plugins/authoring-copilot/components/AcpHtml5InteractiveGenerationContentSubpage.vue";
import AcpImageGenerationContentSubpage from "@plugins/authoring-copilot/components/AcpImageGenerationContentSubpage.vue";
import {
  AcpMo,
  AcpImageEntryType,
  AcpImageEntryAction,
  AcpImageSize,
} from "@plugins/authoring-copilot/types.ts";
import richTextUtils from "@plugins/richtext/utils/richtext.utils.ts";
import { Editor } from "tinymce";
import { EDITOR_MENU_ITEMS } from "./acp-plugin-helper";

export default function (editor: Editor, buttonKey: string) {
  const richTextEditor = editor.options.get("richTextEditor");
  const context = richTextEditor.richTextContext;
  const pluginEvent = editor.options.get("pluginEvent");

  editor.ui.registry.addMenuButton(buttonKey, {
    tooltip: i18n.t("tinymce_plugin_acp_html5_menu_button_tooltip"),
    icon: "interactiveResponse",
    fetch: (callback) => {
      const items = EDITOR_MENU_ITEMS[buttonKey]
        .filter((item) => item.showMenuItem())
        .map((item) => ({
          type: "menuitem",
          text: i18n.t(item.textKey),
          onAction: actionHandlers[item.actionKey],
        }));

      callback(items);
    },
  });

  const actionHandlers = {
    openAcpImage: () => {
      richTextEditor.$contentSubpage.show(
        AcpImageGenerationContentSubpage,
        {
          richTextContext: context,
          size: AcpImageSize.STANDARD_3_2,
          mode: AcpImageEntryType.DEFAULT,
          action: AcpImageEntryAction.NONE,
        },
        {
          "image-added": handleInsertAcpMo,
        },
      );
    },

    openAcpHtml5: () => {
      richTextEditor.$contentSubpage.show(
        AcpHtml5InteractiveGenerationContentSubpage,
        {
          richTextContext: context,
        },
        {
          html5MoCreated: handleInsertAcpMo,
        },
      );
    },
  };

  function handleInsertAcpMo(acpMo: AcpMo, doneCallback?: () => void) {
    richTextUtils.insertInlineAttachment(editor, {
      uuid: acpMo.uuid,
      mediaType: acpMo.fileType,
      fileName: acpMo.fileName,
      type: acpMo.type,
      isAddNewMedia: true,
    });
    richTextUtils.renderInlineMedia(editor, ".inline-placeholder", {
      onMediaSettings: richTextEditor.plugins["mediaObject"]?.openSettings,
    });
    editor.save();
    if (pluginEvent) {
      pluginEvent.$emit("mediaRendered");
    }

    doneCallback?.();
  }
}
